import { IClientDemand, IDemands } from 'types/demands';
import api from '../services/config/api';

export const getDemandData = (id: string | number) =>
  api.get<Omit<IDemands, 'areaInterna'> & { areaInterna: string }>(`/solicitacao/${id}`);

export type responseData = Omit<Omit<IClientDemand, 'serviceType'>, 'prazo'> & {
  serviceType: { id: number; name: string };
  prazo: string;
};

export const getClientDemandData = (id: string | number) =>
  api.get<responseData>(`solicitacao/documentos-consultas/${id}`);

export const getClientFile = (id: string | number) =>
  api.get<Blob>(`solicitacao/download/${id}`, {
    responseType: 'blob',
  });

export const removeClientFile = (id: string | number) =>
  api.delete(`solicitacao/removeDocument/${id}`);
